module.exports = "<!--\n  preserveAspectRatio of xMidYMid meet as the center of the viewport is the circle's\n  center. The center of the circle will remain at the center of the md-progress-spinner\n  element containing the SVG.\n-->\n<svg viewBox=\"0 0 100 100\" preserveAspectRatio=\"xMidYMid meet\">\n  <path></path>\n</svg>"


//////////////////
// WEBPACK FOOTER
// ./src/app/typescripts/pro/progressbars/progress-spinner-module/progress-spinner.component.html
// module id = ./src/app/typescripts/pro/progressbars/progress-spinner-module/progress-spinner.component.html
// module chunks = main